export default function kFormatter(num, decimals = 1) {
  return num > 999 ? (num / 1000).toFixed(decimals) + "k" : num;
}
